import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import Button from "@/components/ui/Button";

interface GuestLoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin: () => void;
  onContinueAsGuest: () => void;
}

export const GuestLoginModal: React.FC<GuestLoginModalProps> = ({
  isOpen,
  onClose,
  onLogin,
  onContinueAsGuest,
}) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 flex items-center justify-center bg-white"
        onClose={onClose}
      >
        <div className="absolute top-4 right-4">
          <button onClick={onClose} className="text-black">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="w-full max-w-md p-6 text-center">
          <h2 className="text-base sm:text-2xl font-bold mb-6">
            Login/Sign up with your phone number
          </h2>
          <div className="w-full flex flex-col items-center gap-4">
            <Button
              variant="primary"
              text="Next"
              className="w-full h-[3rem] md:h-[3.4rem] rounded-[6px] md:rounded-[8px]
                          text-[16px] md:text-[18px] font-bold flex items-center justify-center"
              onClick={onLogin}
            />
            <Button
              variant="secondary"
              text="Continue as Guest"
              className="w-full h-[3rem] md:h-[3.4rem] rounded-[6px] md:rounded-[8px]
                          text-[16px] md:text-[18px] font-bold flex items-center justify-center"
              onClick={onContinueAsGuest}
            />
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default GuestLoginModal;
